'use client';

import { toast as sonnerToast } from '@/components/ui/toaster';

import { TToastOptions, TToastVariant } from '@/components/ui/toaster';

type ToasterToast = TToastOptions & {
  variant?: TToastVariant;
};

type Toast = Omit<ToasterToast, 'id'>;

function toast({ ...props }: Toast) {
  switch (props.variant) {
    case 'success':
      return sonnerToast.success(props.title, props);
    case 'error':
      return sonnerToast.error(props.title, props);
    case 'warning':
      return sonnerToast.warning(props.title, props);
    default:
      return sonnerToast.success(props.title, props);
  }
}

export { toast };
